import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import AdminPageLayout from "../../../components/midpoint/admin/layout/AdminPageLayout";
import AdminPageHeader from "../../../components/midpoint/admin/layout/AdminPageHeader";
import { AdminAutomotiveNav } from "../automotive/AdminAutomotiveNav";
import { slugifyCityInput } from "../../../constants/automapCityExpansionConstants";
import { createExpansionCity, trackCityExpansionEvent } from "../../../services/automapCityExpansionApi";
import { AdminExpansionNav } from "./AdminExpansionShared";

const DEFAULT = {
  city: "",
  citySlug: "",
  department: "",
  region: "",
  metroArea: "",
  priority: "medium",
  targetLaunchDate: "",
  targetDealerCount: 10,
  targetVerifiedDealerCount: 5,
  targetActiveListingCount: 50,
  targetCleanListingCount: 35,
  targetFreshnessPercent: 70,
  targetPhotoCoveragePercent: 85,
  targetAverageQualityScore: 65,
  targetSeoPageCount: 6,
  targetCampaignCount: 3,
  notes: "",
};

export default function AdminExpansionCityFormPage() {
  const navigate = useNavigate();
  const [form, setForm] = useState(DEFAULT);
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError("");
    try {
      const payload = await createExpansionCity({
        ...form,
        citySlug: form.citySlug || slugifyCityInput(form.city),
        targetLaunchDate: form.targetLaunchDate || null,
      });
      trackCityExpansionEvent("city_config_created", { citySlug: payload.city?.citySlug });
      navigate(`/admin/expansion/cities/${payload.city.citySlug}`);
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <AdminPageLayout>
      <AdminPageHeader eyebrow="AutoMapa · Expansión" title="Nueva ciudad" description="Define targets y metadata de lanzamiento." />
      <AdminAutomotiveNav active="expansion" />
      <AdminExpansionNav active="cities" />
      <main className="admin-console__main wrap">
        <form className="admin-form-grid dealer-state-box" onSubmit={submit}>
          {error ? <p className="muted">{error}</p> : null}
          <input required placeholder="Ciudad *" value={form.city} onChange={(e) => setForm({ ...form, city: e.target.value, citySlug: slugifyCityInput(e.target.value) })} />
          <input placeholder="Slug" value={form.citySlug} onChange={(e) => setForm({ ...form, citySlug: e.target.value })} />
          <input required placeholder="Departamento *" value={form.department} onChange={(e) => setForm({ ...form, department: e.target.value })} />
          <input placeholder="Región" value={form.region} onChange={(e) => setForm({ ...form, region: e.target.value })} />
          <input placeholder="Área metro" value={form.metroArea} onChange={(e) => setForm({ ...form, metroArea: e.target.value })} />
          <select value={form.priority} onChange={(e) => setForm({ ...form, priority: e.target.value })}>
            <option value="high">Alta</option>
            <option value="medium">Media</option>
            <option value="low">Baja</option>
          </select>
          <input type="date" value={form.targetLaunchDate} onChange={(e) => setForm({ ...form, targetLaunchDate: e.target.value })} />
          <input type="number" placeholder="Target dealers" value={form.targetDealerCount} onChange={(e) => setForm({ ...form, targetDealerCount: e.target.value })} />
          <input type="number" placeholder="Target verified" value={form.targetVerifiedDealerCount} onChange={(e) => setForm({ ...form, targetVerifiedDealerCount: e.target.value })} />
          <input type="number" placeholder="Target listings" value={form.targetActiveListingCount} onChange={(e) => setForm({ ...form, targetActiveListingCount: e.target.value })} />
          <input type="number" placeholder="Target clean listings" value={form.targetCleanListingCount} onChange={(e) => setForm({ ...form, targetCleanListingCount: e.target.value })} />
          <textarea placeholder="Notas" value={form.notes} onChange={(e) => setForm({ ...form, notes: e.target.value })} />
          <div className="import-actions">
            <button type="submit" className="admin-btn admin-btn--primary" disabled={submitting}>{submitting ? "Guardando…" : "Crear ciudad"}</button>
            <Link className="admin-btn" to="/admin/expansion/cities">Cancelar</Link>
          </div>
        </form>
      </main>
    </AdminPageLayout>
  );
}
